import { css } from '@emotion/react';
import type * as React from 'react';

const hiddenStyle = css`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`;

type Props = {
	readonly children: React.ReactNode;
};

/** Text read by assistive technology only; pairs with an `aria-hidden` visual form. */
const VisuallyHiddenText: React.FC<Props> = ({ children }) => {
	return <span css={hiddenStyle}>{children}</span>;
};

export default VisuallyHiddenText;
